export const defaultEventDomain = 'browser';
//# sourceMappingURL=consts.js.map